export default "__VITE_ASSET__ea81e97b__"